<template>
  <base-dialog
    class="extra-res-dialog"
    :title="title"
    v-model="show"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <project-resource-tree
      :projectid="projectid"
      :class="{ 'extra-res-dialog-disable-edit': disableEdit }"
      ref="extraResTree"
      style="height: 500px; overflow: auto"
      @tree-loaded="onTreeLoaded"
      :disable-handler="calcExtraResTreeDisabled"
    ></project-resource-tree>
  </base-dialog>
</template>
<script>
export default {
  name: 'extra-res-dialog',
  props: {
    title: {
      type: String,
      default: '特殊权限'
    },
    projectid: String,
    uid: String,
    domain: String,
    value: Boolean,
    disableEdit: Boolean
  },
  data() {
    return {
      userResIds: [],
      extraResIds: []
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    refreshProjectResource() {
      if (this.$refs.extraResTree) {
        this.$refs.extraResTree.refreshProjectResource()
      }
    },
    getCheckedKeys() {
      if (this.$refs.extraResTree) {
        return this.$refs.extraResTree.getCheckedKeys()
      }
      return []
    },
    calcExtraResTreeDisabled(data, node) {
      if (this.userResIds.includes(data.id)) {
        return true
      }
      return false
    },
    setExtraResTreeLoading(loading) {
      if (this.$refs.extraResTree) {
        this.$refs.extraResTree.loading = loading
      }
    },
    getUserExtraResView() {
      this.setExtraResTreeLoading(true)
      this.$postObj('/user/getUserExtraResView', {
        domain: this.domain,
        project: this.projectid,
        uid: this.uid
      })
        .then((resp) => {
          this.setExtraResTreeLoading(false)
          if (resp.data.code == 0) {
            this.userResIds = resp.data.data.userResIds || []
            this.extraResIds = resp.data.data.extraResIds || []
            if (this.$refs.extraResTree) {
              var ids = [...new Set([...this.userResIds, ...this.extraResIds])]
              this.$refs.extraResTree.setCheckedKeys(ids)
            }
          } else {
            this.$message(`获取用户特殊权限失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.setExtraResTreeLoading(false)
          console.error('获取用户特殊权限发生异常=>', err)
          this.$message(`获取用户特殊权限发生异常:${err}`)
        })
    },
    onTreeLoaded(tree) {
      this.getUserExtraResView()
    }
  },
  watch: {
    // show: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.getUserExtraResView()
    //     }
    //   }
    // }
  }
}
</script>

<style lang="less">
.extra-res-dialog-disable-edit {
  .el-checkbox {
    opacity: 0.85;
    pointer-events: none;
  }
  .el-tree-node__content {
    cursor: default;
  }
}
</style>
